import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { NavigationExtras, Router } from '@angular/router';
import { Constant } from '../../constants/constant';
import { EncryptService } from './encrypt.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { FormPopupComponent } from '../theme/layout/form-popup/form-popup.component';

export const VALUE = 'localeCode'
export const LOCALEINDEX = 'localeCodeIndex'
export const CURRENCY = "currency";
@Injectable({
  providedIn: 'root'
})
export class CommonService {

	constructor(
		private http: HttpClient, private router: Router,
		private ecryptServiceService: EncryptService,
		// public googleAnalyticsService: AnalyticService,
		public dialog: MatDialog,
		//private userService: UserService
	) { }
	url = environment.serverAPI4 + "/api";
	url2 = environment.serverAPI4 + "/api/ig";

	getCountry(): Observable<Object> {
		return this.http.get(`${this.url}/country`);
	}

	getCountryList(): Observable<Object> {
		let authourized = this.getAuthenticatedUser();
		let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
		if (guestLoginEnabled == "0" || authourized) {
			return this.http.get(`${this.url}/config/country/all?page=0&size=256`);
		} else {
			return this.http.get(`${this.url2}/config/country/all?page=0&size=256`);
		}
	}

	getAuthenticatedUser() {
		let userName = null;
		if (Constant.DEVICE_TYPE == "MOBILE") {
			userName = localStorage.getItem("authenticaterUser");
		} else {
			userName = this.getCookie("user-name");
		}
		return userName;
	}

	getCookie(cname : any) {
		var name = cname + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	saveSearchKeyWords(search: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/ig/searchquery`, search);
	}


	productNavigation(product: any) {

		let productId = product.entityId;
		let name = product.name.replace(/\//g, "-");
		let subProductId = null;

		if (product.type == "Booking") {
			this.router.navigate([`/booking-detail/${name.replace(/\s/g, "_")}/${this.ecryptServiceService.encrypt(productId)}`])
		}

		else if (product.type == "Course") {

			this.router.navigate([`/${name.replace(/\s/g, "_")}/course/${this.ecryptServiceService.encrypt(productId)}`])

		}

		else if (product.configId != null) {
			productId = product.entityId;
			subProductId = product.configId;

			let type = product.type == "Variants Subscription" ? "course" : "product";
			this.router.navigate([`/${name.replace(/\s/g, "_")}/${type}/${this.ecryptServiceService.encrypt(productId)}
		/${this.ecryptServiceService.encryptionAES(subProductId)}/type`])

		}

		else {
			this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(productId)}`])
		}


	}

	productNavigationWishList(product: any,cart:any) {

		let productId = product.entityId;
		let name = product.name.replace(/\//g, "-");
		let subProductId = null;

	 if (product.type == "Course") {

			this.router.navigate([`/${name.replace(/\s/g, "_")}/course/${this.ecryptServiceService.encrypt(productId)}`])

		}

		else{
	
			subProductId = cart.productId;
			productId	 = cart.wishlistItemOption.productId;

			let type ="course";
			this.router.navigate([`/${name.replace(/\s/g, "_")}/${type}/${this.ecryptServiceService.encrypt(productId)}
		/${this.ecryptServiceService.encryptionAES(subProductId)}/type`])

		}

		

	}


	goToCourse(product: any) {

		let productId = product.entityId;
		let name = product.name.replace(/\//g, "-");
		let subProductId = null;

		if ((product.productType == 'Variants Subscription' || product.type == 'Variants Subscription')) {

			if(product.subChild==undefined){
				product.subChild=[];
			}
			if (product.subChild.length > 0) {
				if (product.productType != undefined) {
					subProductId = product.productId;
					productId = product.subChild[0].productId;
				} else {
					subProductId = product.configId;
					productId = product.entityId;
				}

				this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}/${this.ecryptServiceService.encrypt(subProductId)}/type`])
			} else if(product.configId!=undefined) {
				subProductId = product.configId;
				productId = product.entityId;
					this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}/${this.ecryptServiceService.encrypt(subProductId)}/type`])
			}
			else {
				this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}`])
			}



		} else {
			this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}`])
		}


	}

	goToCourseWishList(product: any,name :any) {

		let productId = product.entityId;
		 name = name.replace(/\//g, "-");
		let subProductId = null;

		if ((product.productType == 'Variants Subscription' || product.type == 'Variants Subscription')) {


				subProductId = product.productId;
				productId = product.wishlistItemOption.productId;
					this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}/${this.ecryptServiceService.encrypt(subProductId)}/type`])
			
		


		} else{
			productId = product.productId;
			this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}`])
		}

	}


	productNavigationUrl(product: any) {

		let productId = product.entityId;
		let name = product.name.replace(/\//g, "-");
		let subProductId = null;
		if (product.configId != null) {
			productId = product.entityId;
			subProductId = product.configId;
			this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(productId)}
			/${this.ecryptServiceService.encryptionAES(subProductId)}/type`])

		} else {
			this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(productId)}`])
		}


	}


	productNavigaitionReview(product: any) {

		let productId = product.entityId;
		let subProductId = null;
		let productType = product.productType;

		if (product.subChild == undefined) {
			product.subChild = []
		}



		if (product.subChild.length > 0) {
			productId = product.subChild[0].productId;
			subProductId = product.productId;
			this.router.navigate([`/review/${productId}/${subProductId}/${productType}`])
		}
		if (productId == undefined) {
			productId = product.productId;

			this.router.navigate([`/review/${productId}/${productType}`])
		}


	}



	productNavigationCart(product: any) {
		let productId = product.entityId;
		let subProductId = null;
		let name = product.name.replace(/\//g, "-");

		if (product.subChild == undefined) {
			product.subChild = []
		}



		if (product.subChild.length > 0) {

			productId = product.subChild[0].productId;
			subProductId = product.productId;

			let type = product.productType == "Variants Subscription" ? "course" : "product";
			this.router.navigate([`/${name.replace(/\s/g, "_")}/${type}/${this.ecryptServiceService.encrypt(productId)}
		/${this.ecryptServiceService.encryptionAES(subProductId)}/type`])

		}
		if (product.productType != "Course") {
			if (productId == undefined) {
				productId = product.productId;

				this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(productId)}`])
			}
		}

		if (product.productType == "Course") {
			productId = product.productId;
			this.router.navigate([`/${name.replace(/\s/g, "_")}/course/${this.ecryptServiceService.encrypt(productId)}`])

		}




	}

	productNavigations(product: any) {

		let productId = product.entityId;

		if (productId == undefined) {
			productId = product.productId;
		}
		let name = product.name.replace(/\//g, "-");
		this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(productId)}/type`])
	}
	retrunProductUrl(product: any) {
		let productId = product.entityId;
		let name = product.name.replace(/\//g, "-");
		let subProductId = null;
		let finalValue = null;
		if (product.configId != null) {
			productId = product.entityId;
			subProductId = product.configId;
			finalValue = name.replace(/\s/g, "_") + '/product/' + this.ecryptServiceService.encrypt(productId) + '/' + this.ecryptServiceService.encryptionAES(subProductId) + '/type'
		} else {
			finalValue = name.replace(/\s/g, "_") + '/product/' + this.ecryptServiceService.encrypt(productId)

		}
		return finalValue
	}

	productNavigationReload(url: any) {

		let value = this.router.url.split("/product");

		let nameBeforeUrl = value[0].split("/")

		let name = nameBeforeUrl[1];

		name = name.replace(/\//g, "SLS");
		name = name.replace(/"/g, "Por21Ld245");

		name = name.replace(/\%/g, 'xMl3Jk');
		//name = name.replace(/”/g, '&');
		//name = name.replace(/®/g, 'Ro');
		name = name.replace(/\(/g, 'BRS');
		name = name.replace(/\)/g, 'BREl3jk875');

		name = name.replace(/\+/g, 'plusAdd');

		this.router.navigate([`/${name.replace(/\s/g, "_")}/product/${this.ecryptServiceService.encrypt(name)}`])
	}



	productSearch(name: any) {


		let navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				"sid": this.ecryptServiceService.encryptionAES(name),
			},

		};
		name = name.replace(/\//g, "FWDSLS")
		name = name.replace(/\s/g, "_");
		//name = name.replace(/”/g, '&');
		name = name.replace(/®/g, 'Ro');
		name = name.replace(/\(/g, 'BRS');
		name = name.replace(/\)/g, 'BREl3jk875');

		// name= name.replace(/"/g, "Por21Ld245");
		this.router.navigate([`search/${name}`], navigationExtras);
	}


	customSearch(name: any, header :any) {


		let navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				"sid": this.ecryptServiceService.encryptionAES(name),
			},

		};
		name = name.replace(/\//g, "FWDSLS")
		name = name.replace(/\s/g, "_");
		//name = name.replace(/”/g, '&');
		name = name.replace(/®/g, 'Ro');
		name = name.replace(/\(/g, 'BRS');
		name = name.replace(/\)/g, 'BREl3jk875');
		// name= name.replace(/"/g, "Por21Ld245");
		this.router.navigate([`custom/${header}`], navigationExtras);

	}

	selectedCategory(name: any, id: any, menu: any) {
		if (menu.displayMode == "4") {
			this.router.navigate([menu.urlPath])

		} else if (menu.displayMode == "3") {
			let url = menu.urlPath;

			window.location.href = url
		} else if (menu.displayMode == "5") {

			if (menu.urlPath != null) {

				if (menu.urlPath.trim().length > 0) {
					let url = menu.urlPath;


					if (!url.includes('http://') && !url.includes('https://')) {
						this.router.navigate([url])
					} else {
						window.location.href = url;

					}
				}

			}

		}
		else if (menu.displayMode == "7") {
			this.scrollDown(menu.metaDescription);
		} 

		else {

			this.goToCategory(name, id)
		}
	}

	goToCategory(name: any, id: any) {



		name = name.toString().replace(/\//g, "")


		let navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				"sid": this.ecryptServiceService.encrypt(id)

			},

		};


		//this.googleAnalyticsService.emitEvent("testCategory1", "testAction", "testLabel", 10);
		// this.googleAnalyticsService.event('event_category', name);


		this.router.navigate([`${name.toString().replace(/\s/g, "_")}/pr`], navigationExtras);
	}

	active :any;


	scrollDown(value:any){
		this.active =value;
		this.ScrollIntoView(this.active);
	}

	ScrollIntoView(elem: string) {
		this.active = "#" + elem;
		const ele = document.querySelector(this.active) as HTMLElement;
	  
		if (ele) {
		  const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
		  const paddingTop = 96;
		  window.scrollTo({
			top: offsetTop - paddingTop,
			behavior: 'smooth'
		  });
		} else {
		  console.error('Element not found:', this.active);
		}
	  }
  

	goToCategoryForOtherTypes(products:any, header:any) {

		header = header.replace(/\s/g, "-");
		products = JSON.stringify(products)
		let data = this.ecryptServiceService.encryptionAES(products);
		let navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				"pid": data

			},

		};

		this.router.navigate([`/products-list/${header}`], navigationExtras);
	}


	getEncryptedId(id: any): any {
		return this.ecryptServiceService.encrypt(id);
	}

	getValueForDecryptedData(data: any): any {
		return this.ecryptServiceService.decryptionAES(data);
	}

	getValueForDecryptedDataAes(data: any): any {
		return this.ecryptServiceService.encryptionAES(data);
	}


	goToCategoryWithEncryptedKey(name: any, id: any) {


		let navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				"sid": id

			},

		};
		this.router.navigate([`${name.toString().replace(/\s/g, "_")}/pr`], navigationExtras);
	}


	getSliderData(Page: number, size: number, sort:any): Observable<Object> {
		return this.http.get(`${this.url}/catalog/config/slider/all?page=${Page}&size=${size}&sort=${sort}`);
	}

	getLayoutData(Page: number, size: number, sort:any): Observable<Object> {
		return this.http.get(`${this.url}/catalog/config/slider/advanced/all?page=${Page}&size=${size}&sort=${sort}`);
	}

	getTransaltedValue(value :any, locale : any, Page: any, size: any, sort: any): Observable<Object> {
		let url = environment.serverAPI + "/api/catalog";

		let payload = {
			"value": value,
			"locale": locale
		}
		return this.http.post(`${url}/translate?page=${Page}&size=${size}&sort=${sort}`, payload);

	}

	setLanguageLocale(localeTo: string, index: string) {
		sessionStorage.setItem(VALUE, localeTo);
		sessionStorage.setItem(LOCALEINDEX, index);
	}


	getLocaleIndex() {
		return sessionStorage.getItem(LOCALEINDEX);
	}


	getTranslateCountry() {
		return sessionStorage.getItem(VALUE);
	}


	getCurrencyValue() {
		return localStorage.getItem(CURRENCY);
	}
	setCurrencyValue(value: string) {
		localStorage.setItem(
			CURRENCY,
			value
		);
	}

	getBannerLayout(): Observable<Object> {
		return this.http.get(`${this.url}/catalog/banner/discount`);
	}

	private hasPopupLoaded = false;

	getPopupStatus(): boolean {
		return this.hasPopupLoaded;
	}

	setPopupLoaded(): void {
		this.hasPopupLoaded = true;
	}

	navigateButton(type: any, value: any) {
		if (type == 0) {
			this.openInNewWindow(value)
		} else if (type == 1) {
			this.dynamicFormPopup(value)
		} else if (type == 2) {
			this.scrollDown(value)
		}
	}

	openInNewWindow(url: string) {
		if (url) {
			this.goToLink(url)

		}
	}

	prependProtocol(url: string): string {
		if (!url.includes('http://') && !url.includes('https://')) {
			return 'https://' + url;
		}
		return url;
	}



	dynamicFormPopup(formGroupId: any) {
		if (window.innerWidth > 768) {

			let dialogRef = this.dialog.open(FormPopupComponent, {
				width: '790px',
				data: { formId: formGroupId }
			});

			dialogRef.disableClose = true;
			dialogRef.afterClosed().subscribe(() => {

			});

		}
		else {
			let dialogRef = this.dialog.open(FormPopupComponent, {
				minWidth: '100vw', height: '100vh',
				data: { formId: formGroupId, }
			});

			dialogRef.disableClose = true;
			dialogRef.afterClosed().subscribe(()=> {

			});
		}

	}

	updateTopPosition(): void {

		window.scrollTo({ top: 0, behavior: 'smooth' });

	}

	goToLink(url: any) {
		if (!url.includes('http://') && !url.includes('https://')) {
			this.router.navigate([url])
		} else {
			window.location.href = url;

		}

	}



	productNavigatonCourse(product: any) {
		let productId = product.entityId;
		let subProductId = null;
		let name = product.name.replace(/\//g, "-");

		if (product.subChild == undefined) {
			product.subChild = []
		}



		if (product.subChild.length > 0) {

			productId = product.subChild[0].productId;
			subProductId = product.productId;
			this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}
			/${this.ecryptServiceService.encryptionAES(subProductId)}/type`])
		}

		this.router.navigate([`/${name.replace(/\s/g, "_")}/course-detail/${this.ecryptServiceService.encrypt(productId)}`])





	}

}
